import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=de68977c&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de68977c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de68977c')) {
      api.createRecord('de68977c', component.options)
    } else {
      api.reload('de68977c', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=de68977c&scoped=true&", function () {
      api.rerender('de68977c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/Notifications.vue"
export default component.exports